import React from "react";
import UnderMaintenancePNG from "../../assets/images/UnderMaintenance.png";

const UnderMaintenance = () => {
  return (
    <main className="h-[calc(100vh_-_56px)] w-full text-center flex flex-col items-center justify-center">
      <img
        src={UnderMaintenancePNG}
        alt="UnderMaintenancePNG"
        className="w-56 lg:w-100 h-56 lg:h-100"
      />
      <div className="mt-2 p-2 text-sm md:text-base text-black rounded-md">
        We're Making Things Better! Please Check Back Soon.
      </div>
    </main>
  );
};

export default UnderMaintenance;
